import Card from "./Card"
import Cardt from "./Cardt"
export default {
    Card,
    Cardt
}